import { render } from "./DepartureOverview.vue?vue&type=template&id=6413c661&scoped=true"
import script from "./DepartureOverview.vue?vue&type=script&lang=js"
export * from "./DepartureOverview.vue?vue&type=script&lang=js"

import "./DepartureOverview.vue?vue&type=style&index=0&id=6413c661&scoped=true&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6413c661"]])

export default __exports__